import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

export const FormContent = styled.div`
  padding: 2rem;

  ${tablet768`
    padding: 2rem 2.5rem 2.5rem;
  `}
`;

FormContent.displayName = 'FormContent';
